import { useEffect, useState } from 'react'

import { Col, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap'
import { ArrowRightCircleFill } from 'react-bootstrap-icons'
import { toast } from 'react-toastify'

import TiposService from '../../../../../services/database/TiposService'

import {
  ContainerComponent,
  ContentComponent,
  FooterComponent,
  NextButton,
} from '../../styles'
import { CustomSpinner } from '../../../../CustomSpinner'

export function DadosICMS({ isVisible, onNext, product, handleChange }) {
  const [tipos, setTipos] = useState([])
  const [isLoadingTypes, setIsLoadingTypes] = useState(true)

  async function loadTypes() {
    try {
      setIsLoadingTypes(true)
      const tipos = await TiposService.getAll()

      setTipos(tipos)
    } catch (err) {
      console.log(`Erro ao carregar tipos: ${err}`)
      toast.error('Erro ao carregar os tipos!')
    } finally {
      setIsLoadingTypes(false)
    }
  }

  useEffect(() => {
    if (isVisible) {
      loadTypes()
    }
  }, [isVisible])

  if (!isVisible) {
    return null
  }

  return (
    <ContainerComponent>
      <div>
        <ContentComponent>
          <h4>Dados ICMS / CSOSN</h4>

          <Row className="mb-3">
            <Col>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 5,
                }}
              >
                <Form.Label
                  style={{
                    margin: 0,
                  }}
                >
                  CST ICMS
                </Form.Label>

                {isLoadingTypes && <CustomSpinner size={18} />}
              </div>
              <Form.Select
                name="CST"
                value={product.CST}
                onChange={(e) => handleChange(e, 'icms')}
                disabled={isLoadingTypes}
                style={{
                  marginTop: 8,
                }}
              >
                <option value="">
                  {isLoadingTypes ? 'Carregando...' : 'Selecione uma Opção'}
                </option>
                {tipos
                  .filter((tipo) => tipo.TIPO === 'CSOSN')
                  .map((tipo) => (
                    <option
                      key={tipo.ID}
                      value={tipo.CODIGO}
                    >
                      {tipo.DESCRICAO}
                    </option>
                  ))}
              </Form.Select>
            </Col>

            <Col>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 5,
                }}
              >
                <Form.Label
                  style={{
                    margin: 0,
                  }}
                >
                  CSOSN (Simples Nacional)
                </Form.Label>

                {isLoadingTypes && <CustomSpinner size={18} />}
              </div>

              <Form.Select
                name="CSOSN"
                value={product.CSOSN}
                onChange={(e) => handleChange(e, 'icms')}
                style={{
                  marginTop: 8,
                }}
                disabled={isLoadingTypes}
              >
                <option value="">
                  {isLoadingTypes ? 'Carregando...' : 'Selecione uma Opção'}
                </option>

                {tipos
                  .filter((tipo) => tipo.TIPO === 'CST PIS')
                  .map((tipo) => (
                    <option
                      key={tipo.ID}
                      value={tipo.CODIGO}
                    >
                      {tipo.DESCRICAO}
                    </option>
                  ))}
              </Form.Select>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 5,
                }}
              >
                <Form.Label
                  style={{
                    margin: 0,
                  }}
                >
                  Origem do Produto
                </Form.Label>

                {isLoadingTypes && <CustomSpinner size={18} />}
              </div>

              <Form.Select
                name="ORIGEM"
                value={product.ORIGEM}
                onChange={(e) => handleChange(e, 'icms')}
                disabled={isLoadingTypes}
                style={{
                  marginTop: 8,
                }}
              >
                <option value="">
                  {isLoadingTypes ? 'Carregando...' : 'Selecione uma Opção'}
                </option>
                {tipos
                  .filter((tipo) => tipo.TIPO === 'ORIGEM')
                  .map((tipo) => (
                    <option
                      key={tipo.ID}
                      value={tipo.CODIGO}
                    >
                      {tipo.DESCRICAO}
                    </option>
                  ))}
              </Form.Select>
            </Col>

            <Col>
              <Form.Label>% ICMS</Form.Label>
              <Form.Control
                name="ICMS"
                value={product.ICMS}
                onChange={(e) => handleChange(e, 'icms')}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Label>ICMS ST (Retido)</Form.Label>
              <Form.Control
                name="ICMSST"
                value={product.ICMSST}
                onChange={(e) => handleChange(e, 'icms')}
              />
            </Col>

            <Col>
              <Form.Label>Base Cálculo ICMS ST (Retido)</Form.Label>
              <Form.Control
                name="BASEICMSST"
                value={product.BASEICMSST}
                onChange={(e) => handleChange(e, 'icms')}
              />
            </Col>

            <Col>
              <Form.Label> CEST </Form.Label>
              <Form.Control
                name="CEST"
                value={product.CEST}
                onChange={(e) => handleChange(e, 'icms')}
              />
            </Col>
          </Row>
        </ContentComponent>

        <FooterComponent>
          <OverlayTrigger overlay={<Tooltip>Avançar</Tooltip>}>
            <NextButton onClick={onNext}>
              <ArrowRightCircleFill
                size={15}
                color="white"
              />
            </NextButton>
          </OverlayTrigger>
        </FooterComponent>
      </div>
    </ContainerComponent>
  )
}
